import React, { useCallback, useMemo, useContext } from 'react'
import OptionsMenu from '../../../../Common/OptionsMenu/OptionsMenu'
import SectionFormContainer from '../../../components/SectionFormContainer'
import GroomingAppointmentWizardContext from '../GroomingAppointmentWizardContext'
import useGroomingVisit from '../../../../../hooks/useGroomingVisit'

const HAIR_LENGTH_OPTIONS = [
	{
		label: 'Less than 1 inch long',
		value: 'Less than 1 inch long'
	},
	{
		label: '1 to 2 inches long',
		value: '1 to 2 inches long'
	},
	{
		label: 'More than 2 inches long',
		value: 'More than 2 inches long'
	}
]

const HairLength = (props) => {
	const {
		wizardContextProvider: { grooming_appointment, setWizardAttributeAndValues }
	} = useContext(GroomingAppointmentWizardContext)
	const { visit_attr, title = '', subtext = '' } = props
	const { loading, facility } = useGroomingVisit()

	const handleSelection = useCallback(
		(type) => {
			const newValues = { ...grooming_appointment }
			newValues[visit_attr] = type
			setWizardAttributeAndValues(newValues)
		},
		[grooming_appointment, setWizardAttributeAndValues, visit_attr]
	)

	const options = useMemo(() => {
		const opts = HAIR_LENGTH_OPTIONS.map(({ label, value }, i) => {
			const option = {
				title: label,
				id: i,
				disabled: loading || grooming_appointment[visit_attr] === value,
				selected: grooming_appointment[visit_attr] === value,
				onSelected: () => handleSelection(value)
			}
			return option
		})

		return opts
	}, [facility, handleSelection, loading, grooming_appointment, visit_attr])

	return (
		<SectionFormContainer title={title} subtext={subtext}>
			<OptionsMenu options={options} />
		</SectionFormContainer>
	)
}

export default HairLength
